function qaAttribute(value: string, isString?: false): { 'data-q': string };
function qaAttribute(value: string, isString: true): string;
function qaAttribute(value: string, isString?: boolean) {
    return isString
        ? `data-q="${value}"` // attribute string.
        : { 'data-q': value }; // attribute object.
}

export { qaAttribute };
